import { __rest } from "tslib";
import React from 'react';
import { Message } from '@marvelapp/ui';
import { Text } from './Text';
export function InputError(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Message, Object.assign({ kind: "error", mt: "s" }, props),
        React.createElement(Text, { fontSize: "s" }, children)));
}
